import { Brain } from "@phosphor-icons/react";

import {
  type ProjectFeedEvent,
  type ProjectMemoryPayload,
} from "../../../services/askPunttProjectFeed.types";

/**
 * "Saved to project memory" confirmation card shown after a `@Puntt remember`
 * instruction is committed (instruction_committed / memory_saved). Tinted
 * strip + brain icon per the mockup; the committed instruction text is shown
 * below the confirmation when present in the payload.
 */
export function FeedMemoryCard({ event }: { event: ProjectFeedEvent }) {
  const payload = (event.payload ?? {}) as ProjectMemoryPayload;
  const instruction = payload.instruction ?? event.body;

  return (
    <section
      className="rounded-xl border border-puntt-blue-6 bg-puntt-blue-2 p-3.5"
      data-testid="project-feed-memory-saved"
      aria-label="Saved to project memory"
    >
      <div className="flex items-center gap-2.5">
        <span
          aria-hidden="true"
          className="flex size-8 shrink-0 items-center justify-center rounded-full bg-puntt-blue-3 text-puntt-accent-9"
        >
          <Brain size={16} weight="fill" />
        </span>
        <span className="text-[13px] font-semibold text-puntt-accent-11">
          Saved to project memory
        </span>
      </div>
      {instruction && (
        <p
          className="mt-2 text-[12.5px] leading-relaxed text-puntt-neutral-gray-12"
          data-testid="project-feed-memory-instruction"
        >
          {instruction}
        </p>
      )}
    </section>
  );
}
